import { NgModule } from '@angular/core';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { GooglePickerComponent } from './google-picker/google-picker.component';

@NgModule({
	exports: [
		MatSnackBarModule,
		MatTabsModule,
		MatCheckboxModule,
		MatRadioModule,
		MatCardModule,
		MatIconModule,
		MatMenuModule,
		MatAutocompleteModule,
		MatFormFieldModule,
		MatInputModule,
		MatTableModule,
		MatDialogModule,
		MatListModule,
		MatSelectModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatPaginatorModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatDividerModule,
		MatExpansionModule,
		MatTooltipModule,
		MatSlideToggleModule,
		MatRippleModule,
		MatDatepickerModule,
		MatIconModule
	],
	declarations: [ 
		
  	],
})
export class MaterialModule {}
